import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { CategorieService } from '../../../services/simple/categorie.service';
import { TvaModel } from './../../../models/simple-types/tva.model';
import { CategorieModel } from '../../../models/simple-types/categorie.model';
import { GestionNaComponent } from '../../../../core/gestion-referentiel/gestion-na/gestion-na.component';
import { NaModel } from 'src/app/shared/models/simple-types/na.model';
import { Form, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Component, OnInit, Inject, OnChanges } from '@angular/core';

export interface DialogData {
    form: UntypedFormGroup;
    tvas: TvaModel[];
    categories: CategorieModel[];
    result: boolean;
  }
@Component({
  selector: 'app-modal-add-categorie',
  templateUrl: './modal-add-categorie.component.html',
  styleUrls: ['./modal-add-categorie.component.scss']
})
export class ModalAddCategorieComponent implements OnInit {

    categories: CategorieModel[];
    form: UntypedFormGroup;
    tva: TvaModel;
    constructor(public dialog: MatDialog
              , public dialogRef: MatDialogRef<GestionNaComponent>
              , @Inject(MAT_DIALOG_DATA) public data: DialogData
              , private toastr: ToastrService
              , private router: Router
              , private categorieService: CategorieService) {
               }

  ngOnInit(): void {
    this.categories = this.data.categories;
    this.form = this.data.form;
    if (this.form) {
      this.tva = this.data.tvas.find(s => s.code === this.form.get('codeTva').value);
    }
  }

  onModalCancel(): void {
    this.data.result = false;
    this.dialogRef.close(false);
  }

  onModalConfirm(): void {
    if (this.form.valid) {
      const categorie = this.form.getRawValue();
      this.tva ? categorie.codeTva = this.tva.code : categorie.codeTva = '';
      // Création
      if (!this.form.get('id').value){
        const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.categorieService.save(categorie).subscribe((a: CategorieModel) => {
            this.toastr.success('', 'Création de la categorie ' + a.code + ' réussie');
            this.dialogRef.close(a);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(false);
            dialogRef.close();
          });
      }else { // Modification
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.categorieService.update(categorie.id, categorie).subscribe((a: CategorieModel) => {
          this.toastr.success('', 'Modification de la categorie ' + a.code + ' réussie');
          this.dialogRef.close(a);
          dialogRef.close();
        }, (error) => {
          this.dialogRef.close(false);
          dialogRef.close();
        });
      }
    } else {
      this.displayErrors();
      this.toastr.warning('', 'Veuillez remplir les champs obligatoire');
    }
  }

  displayErrors(): void {
    for (const index in this.form.controls) {
      if (index) {
        this.form.controls[index].markAsTouched();
      }
    }
  }
}

